import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { updateDoc, doc, arrayUnion } from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { GameModeEnum, GameStateEnum, GameStatusEnum } from "interfaces/game";
import { setGame } from "stores/game/GameSlice";

function RoleSelection({
  db,
  blueSideTeam,
  redSideTeam,
  isTimerUpperThreshold,
  isLockedIn,
  setIsLockedIn,
}) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);
  const game = useSelector((state) => state.gameReducer.game);

  const roles = ["top", "jungle", "mid", "bottom", "support"];

  const playerSide = game.players.findIndex((player) => player === user?.uid);
  const blueSideUserId = game?.players[0];
  const redSideUserId = game?.players[1];

  const createTeamRecord = (team) => {
    if (!team) return null;

    return roles.reduce(
      (acc, role, index) => ({
        ...acc,
        [role]: team[index]?.championId,
      }),
      {},
    );
  };

  const blueTeamRecord = createTeamRecord(blueSideTeam);
  const redTeamRecord = createTeamRecord(redSideTeam);

  const lockInRoles = async () => {
    if (game.mode === GameModeEnum.SIMULATION) {
      const userTeams = [
        {
          team: blueTeamRecord,
          userId: blueSideUserId,
        },
        {
          team: redTeamRecord,
          userId: redSideUserId,
        },
      ];
      dispatch(
        setGame({
          ...game,
          teams: userTeams,
          state: GameStateEnum.FINISHED,
        }),
      );
    } else {
      const isPlayerBlueSide = playerSide === 0;
      const pickedChampionsUpdate = isPlayerBlueSide
        ? { bluePickedChampions: blueSideTeam }
        : { redPickedChampions: redSideTeam };

      await updateDoc(doc(db, "games", game?.id), {
        teams: arrayUnion({
          userId: user.uid,
          team: isPlayerBlueSide ? blueTeamRecord : redTeamRecord,
        }),
        rolesLockedIn: arrayUnion(user.uid),
        ...pickedChampionsUpdate,
      });

      if (
        !game?.rolesLockedIn?.includes(user.uid) &&
        game?.rolesLockedIn?.length >= 1 &&
        game.state !== GameStateEnum.FINISHED
      ) {
        await updateDoc(doc(db, "games", game.id), {
          state: GameStateEnum.FINISHED,
          status: GameStatusEnum.RESULTS,
        });
      }
    }
    setIsLockedIn(true);
  };

  useEffect(() => {
    if (game.mode !== GameStateEnum.SIMULATION) {
      if (!isTimerUpperThreshold && !isLockedIn) {
        lockInRoles();
      }
    }
    return () => {};
  }, [isTimerUpperThreshold, isLockedIn]);

  return (
    <div className="RoleSelection roleSelectionContainer">
      <section className="buttonContainer">
        <motion.button
          onClick={lockInRoles}
          className={`lockButton ${isLockedIn ? "locked" : "blinking"}`}
          // disabled={isLockedIn}
          whileHover={{ scale: isLockedIn ? 1.0 : 1.1 }}
          whileTap={{ scale: isLockedIn ? 1.0 : 0.9 }}
        >
          LOCK IN
        </motion.button>
      </section>
    </div>
  );
}

export default RoleSelection;
